const fieldData = {
  'Applicant Full Name': 'audit_applicant_full_name',
  'Mailing Address': 'audit_mailing_address',
  'Property Address': 'audit_property_address',
  'Date of Birth': 'audit_date_of_birth',
  'Social Security Number': 'audit_ssn',
  'Lien Holder': 'audit_lien_holder',
  'Lien Holder Balance': 'audit_lien_holder_balance',
}

const reportData = {
  'Credit Report': 'credit-report-xml',
  'AVM Report': 'avm-report-xml',
  'Title Report': 'title-report-xml',
  'Appraisal Report': 'appraisal-xml',
}

export function getColumnData(data) {
  return Object.keys(fieldData).map((field) => {
    return {
      field,
      creditReport: data?.[reportData['Credit Report']]?.[fieldData[field]],
      avmReport: data?.[reportData['AVM Report']]?.[fieldData[field]],
      titleReport: data?.[reportData['Title Report']]?.[fieldData[field]],
      appraisalReport: data?.[reportData['Appraisal Report']]?.[fieldData[field]],
    }
  })
}
